module.exports = __webpack_public_path__ + "static/toggl-track-main-2bf24caf103add6b5d6f637f80259575.jpg";